<template>
    <transition name="slide">
        <div v-if="isVisible">
            <div class="modal-backdrop fade show"></div>
            <div class="modal fade show d-flex" data-bs-target="#staticBackdrop">
                <div 
                    class="modal-dialog modal-dialog-centered modal-dialog-scrollable" :class="modal_size"
                >
                    <div class="modal-content p-4">
                        <div class="d-flex flex-row align-items-center justify-content-between">
                            <span v-if="title_centered"></span>
                            <h5>{{ title }}</h5>
                            <button type="button" class="btn-close" @click="handleCancel" aria-label="Close">
                            </button>
                        </div>
                        <div class="modal-body px-0 py-3" v-html="message">
                        </div>
                        <div class="modal-footer border-0">
                            <button type="button" class="btn btn-primary rounded" @click="handleOk">{{ok_text}}</button>
                            <button type="button" class="btn btn-danger rounded" @click="handleCancel">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'ModalConfirmComponent',
    props: {
        title_centered: {
            type: Boolean,
            default: false, 
        },
        ok_text: {
            type: String,
            default: 'Yes',
        },
    },
    data() {
        return {
            isVisible: false,
            resolve: null,
            reject: null,
            message: null,
            modal_size: 'modal-md',
            title: 'Confirm',
        };
    },
    methods: {
        handleOk() {
            this.hide();
            if (this.resolve) {
                this.resolve();
            }
        },
        handleCancel() {
            this.hide();
            if (this.reject) {
                this.reject();
            }
        },
        show() {
            document.body.style.overflow = 'hidden';
            this.isVisible = true;
        },
        hide() {
            document.body.style.overflow = 'auto';
            this.isVisible = false;
        },
        open(msg,size = 'modal-md', title = 'Confirm') {
            this.title      = title;
            this.message    = msg;
            this.modal_size = size;
            this.show();
            return new Promise((resolve, reject) => {
                this.resolve = resolve;
                this.reject = reject;
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.slide-enter-active, .slide-leave-active {
  transition: transform 0.8s ease, opacity 0.3s ease;
}

.slide-enter {
  transform: translateY(100%); 
  opacity: 0; 
}

.slide-leave-to {
  transform: translateY(-100%); 
  opacity: 0;
}
</style>